const marginKeys = [
  'margin',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'm',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
];

const paddingKeys = [
  'padding',
  'p',
  'paddingTop',
  'pt',
  'paddingRight',
  'pr',
  'paddingBottom',
  'pb',
  'paddingLeft',
  'pl',
  'px',
  'py',
];

const spaceKeys = ['spaceY', 'spaceX', 'spaceXReverse', 'spaceYReverse'];

const widthKeys = ['width', 'w', 'maxWidth', 'maxW', 'minWidth', 'minW'];

const heightKeys = ['height', 'h', 'maxHeight', 'maxH', 'minHeight', 'minH'];

const maskSizeKeys = ['maskSize'];

const spacingKeys = [...marginKeys, ...paddingKeys, ...spaceKeys];
const sizingKeys = [...widthKeys, ...heightKeys, ...maskSizeKeys];
export const layoutKeys = [
  'display',
  'float',
  'boxSizing',
  'container',
  'overflow',
  'overflowX',
  'overflowY',
  'zIndex',
  'position',
  'top',
  'right',
  'bottom',
  'left',
  'visibility',
  'overscrollBehavior',
  'objectFit',
];

export const borderKeys = [
  'border',
  'borderTop',
  'borderBottom',
  'borderRight',
  'borderLeft',
  'borderColor',
  'borderTopColor',
  'borderBottomColor',
  'borderRightColor',
  'borderLeftColor',
  'borderStyle',
  'borderTopStyle',
  'borderBottomStyle',
  'borderRightStyle',
  'borderLeftStyle',
  'borderWidth',
  'borderTopWidth',
  'borderBottomWidth',
  'borderRightWidth',
  'borderLeftWidth',
  'borderRadius',
];

export const backgroundKeys = ['backgroundColor', 'bg'];

export const colorKeys = ['color'];

export const boxShadowKeys = ['boxShadow'];

export const typographyKeys = ['fontWeight', 'textAlign'];

export const xstyledKeys = Object.fromEntries(
  [
    ...spacingKeys,
    ...sizingKeys,
    ...layoutKeys,
    ...borderKeys,
    ...backgroundKeys,
    ...colorKeys,
    ...boxShadowKeys,
    ...typographyKeys,
  ].map((item) => [item, true]),
) as Record<string, true>;
